// extracted by mini-css-extract-plugin
export var container = "Header-module--container--DfhdH";
export var animation = "Header-module--animation--Zxdum";
export var fadeIn = "Header-module--fadeIn--3Z3pl";